// extracted by mini-css-extract-plugin
export default {"container":"NO-z","topReviewHeading":"OO-z","criticalReview":"PO-z","favorableReview":"QO-z","vsSeparator":"RO-z"};